"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeItem = removeItem;
const path = __importStar(require("path"));
async function removeItem(input, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    // Archived refs aren't in the live index — delete them by path under loom/.archive/
    // (mirror of loom_restore's archivedRelPath). Guarded to .archive/.
    if ('archivedRelPath' in input && input.archivedRelPath) {
        const archiveRoot = path.join(loomRoot, 'loom', '.archive');
        const target = path.resolve(archiveRoot, input.archivedRelPath);
        if (target !== archiveRoot && !target.startsWith(archiveRoot + path.sep)) {
            throw new Error(`Refused: '${input.archivedRelPath}' is outside loom/.archive/.`);
        }
        if (!(await deps.fs.pathExists(target))) {
            throw new Error(`Nothing to delete at .archive/${input.archivedRelPath}.`);
        }
        await deps.fs.remove(target);
        return { removed: target };
    }
    if ('id' in input && input.id) {
        const { filePath } = await deps.resolveDocIdOrThrow(loomRoot, input.id);
        await deps.fs.remove(filePath);
        return { removed: filePath };
    }
    if ('weaveId' in input && input.weaveId) {
        const rel = input.threadId
            ? path.join(input.weaveId, input.threadId)
            : input.weaveId;
        const live = path.join(loomRoot, 'loom', rel);
        const archived = path.join(loomRoot, 'loom', '.archive', rel);
        // Delete wherever the folder actually lives — an archived item is under
        // loom/.archive/ mirroring its path, not the live tree.
        const target = (await deps.fs.pathExists(live)) ? live
            : (await deps.fs.pathExists(archived)) ? archived
                : null;
        if (!target) {
            throw new Error(`Nothing to delete at ${rel} (checked live and .archive).`);
        }
        await deps.fs.remove(target);
        return { removed: target };
    }
    throw new Error('removeItem requires either { id } or { weaveId, threadId? }.');
}
